"use client";

import React from "react";
import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";

import {
  mobileAppDesignHeroData,
  mobileDesignStatsData,
  mobileDesignSolutionsAndProcessData,
  mobileDesignPortfolioData,
  mobileDesignTechnologiesData,
  mobileDesignAboutData,
  mobileAppDesignFaqs,
} from "src/utils/mock/mobileAppDesignData";

import { caseStudies } from "src/utils/mock/caseStudies";
import CommonContactSection from "src/components/Common/CommonContactSection";

export default function MobileAppDesignComponent({ caseStudies: apiCaseStudies }) {
  const finalCaseStudies = apiCaseStudies || caseStudies;
  const liveProjects = finalCaseStudies?.projects?.liveProjects || [];

  const activeProjects = liveProjects.filter((project) => {
    const isMobileDesign = project.platforms?.toLowerCase().includes("mobile");
    return project.projectStatus?.toLowerCase() === "active" && isMobileDesign;
  });

  const filteredData = {
    ...mobileDesignPortfolioData,
    projects: {
      liveProjects: activeProjects,
    },
  };
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={mobileAppDesignHeroData} />
      <TechStats stats={mobileDesignStatsData} />
      <WhyChooseUs data={mobileDesignSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={mobileDesignTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About Mobile App Design" sections={mobileDesignAboutData} />
        </div>
      </section>

      <FAQSection faqs={mobileAppDesignFaqs} />
      <CommonContactSection />
    </div>
  );
}
